type ValidationError = {
  message: string;
  name: string;
  isVisible: boolean;
  errors: {
    [key: string]: {
      message: string;
      name: string;
      properties: {
        type: string;
        message: string;
        path: string;
        value?: any;
      };
      kind: string;
      path: string;
      value?: any;
    };
  };
};

type ValidationErrorsById = {
  [id: string]: ValidationError;
};
export class DrinkService  {
  drinkOrder: number = 0;
  inValidDrinks: ValidationErrorsById = {};
  constructor() {
      'ngInject';
    }
  setDrinkOrder = (order: number) => {
    this.drinkOrder = order;
    return this.drinkOrder;
  }
  setInValidDrinks = (drinks: ValidationErrorsById) => {
    this.inValidDrinks = drinks;
  }
}
